import { render, staticRenderFns } from "./PopupFeedBack.vue?vue&type=template&id=553a6108"
import script from "./PopupFeedBack.vue?vue&type=script&lang=js"
export * from "./PopupFeedBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports